const PROMPT_DRIVEN_TASK_TYPES = new Set([0, 1]);

/**
 * Photo (1) and Text (0) AI vs standard is stored as a prompt, not task_subtype.
 * The API keeps task_subtype at 0 for those types.
 * @param {number|string} taskType
 * @returns {boolean}
 */
export const isPromptDrivenTaskType = (taskType) => (
    PROMPT_DRIVEN_TASK_TYPES.has(Number(taskType))
);

/**
 * @param {string} [prompt]
 * @returns {boolean}
 */
export const hasTransformationPrompt = (prompt) => Boolean(String(prompt ?? '').trim());

/**
 * Derive the UI subtype for prompt-driven challenge types.
 * @param {string} [prompt]
 * @returns {0|1}
 */
export const subtypeFromPrompt = (prompt) => (hasTransformationPrompt(prompt) ? 1 : 0);
